import {Trans, useLingui} from '@lingui/react/macro'

import {
  useContentSourceQuery,
  useSetContentSourceMutation,
} from '#/state/queries/content-source'
import * as Toast from '#/view/com/util/Toast'
import * as SettingsList from '#/screens/Settings/components/SettingsList'
import {atoms as a} from '#/alf'
import * as Toggle from '#/components/forms/Toggle'
import {Beaker_Stroke2_Corner2_Rounded as BeakerIcon} from '#/components/icons/Beaker'

export function ContentSourceGroup() {
  const {t: l} = useLingui()
  const {data: contentSourceData} = useContentSourceQuery()
  const {mutate: setContentSource} = useSetContentSourceMutation()
  const isWsocial = (contentSourceData?.source ?? 'federated') === 'wsocial'

  return (
    <>
      <SettingsList.Divider />
      <SettingsList.Group>
        <SettingsList.ItemIcon icon={BeakerIcon} />
        <SettingsList.ItemText>
          <Trans>Experimental</Trans>
        </SettingsList.ItemText>
        <Toggle.Item
          type="checkbox"
          name="only-verified-users"
          label={l`Only verified users`}
          value={isWsocial}
          onChange={value =>
            setContentSource(value ? 'wsocial' : 'federated', {
              onError: () =>
                Toast.show(
                  l`Failed to switch content source. Please try again.`,
                  'xmark',
                ),
            })
          }
          style={[a.w_full, a.gap_md]}>
          <Toggle.LabelText style={[a.flex_1]}>
            <Trans>Only verified users</Trans>
          </Toggle.LabelText>
          <Toggle.Platform />
        </Toggle.Item>
      </SettingsList.Group>
    </>
  )
}
